/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { GuidanceResource } from "./GuidanceResource";
export const GuidanceListResponse = core.serialization.object({
    data: core.serialization.list(GuidanceResource),
});
